import React from 'react';
import { Field } from 'formik';
import { Link, useLocation } from 'react-router-dom';
import { FormLabel, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormField from '../FormField';

const useStyles = makeStyles(theme => ({
	field: {
		marginLeft: theme.spacing(1)
	},
	label: {
		margin: theme.spacing(2),
		textAlign: 'left'
	},
	value: {
		margin: theme.spacing(2)
	}
}));

const invoiceFilters = {
	status: { constant: true, value: 'active' },
	invoiceStatus: { constant: true, value: 'filed' }
};

function OriginalInvoiceField({ record, label, name, type, readOnly }) {
	const classes = useStyles();
	const location = useLocation();
	const fromInvoice = new URLSearchParams(location.search).has('invoiceId');
	if (!record.id && !readOnly && !fromInvoice)
		return (
			<Field
				name={name}
				type={type}
				label={label}
				record={record}
				filters={invoiceFilters}
				customLabelField="invoiceNumber"
				component={FormField}
			/>
		);
	return (
		<Grid container className={classes.field}>
			<Grid container item xs={3}>
				<FormLabel className={classes.label}>{label}:</FormLabel>
			</Grid>
			<Grid item xs>
				<Typography className={classes.value}>
					{record.invoiceId ? (
						<Link to={`/invoice/${record.invoiceId}`}>
							{record.invoice_invoiceNumber || record.invoiceId}
						</Link>
					) : null}
				</Typography>
			</Grid>
		</Grid>
	);
}

export default OriginalInvoiceField;
